import * as types from '../actions/types';

const initialState = {
  // Кнопки главного меню
  buttons: [],
  buttonsLoading: false,

  // Файлы заставки
  files: [],
  filesLoading: false,
  fileUploading: false,

  // Настройки заставки
  settings: {
    timeout_sec: 10,
    sleep_after_sec: 120
  },
  settingsLoading: false,

  // Флаг несохраненных изменений
  hasChanges: false
};

export default function infoKiosk(state = initialState, action) {
  switch (action.type) {
    case types.SET_INFO_KIOSK_BUTTONS:
      return { ...state, buttons: action.payload };
    case types.SET_INFO_KIOSK_BUTTONS_LOADING:
      return { ...state, buttonsLoading: action.payload };
    case types.SET_INFO_KIOSK_FILES:
      return { ...state, files: action.payload };
    case types.SET_INFO_KIOSK_FILES_LOADING:
      return { ...state, filesLoading: action.payload };
    case types.SET_INFO_KIOSK_FILE_UPLOADING:
      return { ...state, fileUploading: action.payload };
    case types.SET_INFO_KIOSK_SETTINGS:
      return { ...state, settings: action.payload };
    case types.SET_INFO_KIOSK_SETTINGS_LOADING:
      return { ...state, settingsLoading: action.payload };
    case types.SET_INFO_KIOSK_HAS_CHANGES:
      return { ...state, hasChanges: action.payload };
    default:
      return state;
  }
}
